export const STATISTICS = [
  {
    id: "hectares",
    value: 271,
    suffix: "",
    labelEn: "Hectares",
    labelRu: "Гектаров",
    icon: "Mountain",
    descEn: "Of prime Andean farmland",
    descRu: "Плодородных земель в Андах",
  },
  {
    id: "varieties",
    value: 350,
    suffix: "+",
    labelEn: "Rose varieties",
    labelRu: "Сортов роз",
    icon: "Flower2",
    descEn: "Continuously curated",
    descRu: "Постоянно обновляемая коллекция",
  },
  {
    id: "professionals",
    value: 3000,
    suffix: "+",
    labelEn: "Professionals",
    labelRu: "Специалистов",
    icon: "Users",
    descEn: "Caring for every stem",
    descRu: "Заботятся о каждом стебле",
  },
  {
    id: "continents",
    value: 5,
    suffix: "",
    labelEn: "Continents",
    labelRu: "Континентов",
    isText: true,
    textEn: "Five",
    textRu: "Пять",
    icon: "Globe",
    descEn: "Markets reached",
    descRu: "География поставок",
  },
  {
    id: "years",
    value: 29,
    suffix: "",
    labelEn: "Years",
    labelRu: "Лет",
    icon: "Award",
    descEn: "Of floral expertise",
    descRu: "Экспертизы в цветочном бизнесе",
  },
];
